import { useEffect, useState } from "react";
import moment from "moment/moment";
import { withAppHOC, withAccountHOC } from "../../hoc";
import {
  Button,
  Dropdown,
  Fieldset,
  Form,
  Label,
  MessageBox,
  MobileInput,
  TextInput,
} from "../../components/FormElements";
import Loader from "../../components/Loader/Loader";
import { StyledFormContainer } from "../../components/Styled";
import API from "../../api";
import { RESPONSE_STATUSES } from "../../constants";
import { setLocalStorage } from "../../utils";

const Profile = () => {
  const [state, setState] = useState({
    isLoading: false,
    apiResponseStatus: "",
    apiResponseMessage: "",
    userProfile: {
      fullName: "",
      mobileNumber: "",
      gender: "",
      dateOfBirth: "",
    },
  });

  const setStateData = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const fetchProfile = async () => {
    try {
      setStateData("isLoading", true);
      const response = await API.get("/authentication/profile");
      const { status, message, data } = response?.data;
      if (status === RESPONSE_STATUSES.SUCCESS) {
        setStateData("userProfile", {
          ...data,
          dateOfBirth: data?.dateOfBirth
            ? moment(data?.dateOfBirth).format("YYYY-MM-DD")
            : "",
        });
      } else {
        setStateData("apiResponseStatus", RESPONSE_STATUSES.FAILED);
        setStateData("apiResponseMessage", message);
      }
    } catch (error) {
      console.error(error);
      setStateData("apiResponseStatus", RESPONSE_STATUSES.FAILED);
      setStateData("apiResponseMessage", error.message);
    } finally {
      setStateData("isLoading", false);
    }
  };

  const updateProfile = async (e) => {
    try {
      e?.preventDefault();
      setStateData("isLoading", true);
      const response = await API.put("/authentication/profile", {
        ...state.userProfile,
      });
      const { status, message, data } = response?.data;
      if (status === RESPONSE_STATUSES.SUCCESS) {
        setLocalStorage("userProfile", JSON.stringify(data));
        setTimeout(() => {
          setStateData("apiResponseStatus", "");
          setStateData("apiResponseMessage", "");
        }, 3000);
      }
      setStateData("apiResponseStatus", status);
      setStateData("apiResponseMessage", message);
    } catch (error) {
      console.error(error);
      setStateData("apiResponseStatus", RESPONSE_STATUSES.FAILED);
      setStateData("apiResponseMessage", error.message);
    } finally {
      setStateData("isLoading", false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <>
      <Loader isLoading={state.isLoading} />
      <StyledFormContainer>
        <Form action="#" method="POST" onSubmit={updateProfile}>
          <Fieldset>
            <Label required>Full Name</Label>
            <TextInput
              value={state.userProfile.fullName}
              onChange={(value) =>
                setState((prevState) => ({
                  ...prevState,
                  userProfile: { ...prevState.userProfile, fullName: value },
                }))
              }
              placeholder="Full Name"
              disabled={state.isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label required>Mobile Number</Label>
            <MobileInput
              value={state.userProfile.mobileNumber}
              onChange={(value) =>
                setState((prevState) => ({
                  ...prevState,
                  userProfile: {
                    ...prevState.userProfile,
                    mobileNumber: value,
                  },
                }))
              }
              placeholder="Mobile Number"
              disabled={true}
            />
          </Fieldset>
          <Fieldset>
            <Label required>Gender</Label>
            <Dropdown
              value={state.userProfile.gender}
              onChange={(value) =>
                setState((prevState) => ({
                  ...prevState,
                  userProfile: { ...prevState.userProfile, gender: value },
                }))
              }
              placeholder="Gender"
              options={[
                { name: "Select Gender", value: "" },
                { name: "Male", value: "Male" },
                { name: "Female", value: "Female" },
                { name: "Others", value: "Others" },
              ]}
              disabled={state.isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label required>Date Of Birth</Label>
            <TextInput
              type="date"
              value={state.userProfile.dateOfBirth}
              onChange={(value) =>
                setState((prevState) => ({
                  ...prevState,
                  userProfile: { ...prevState.userProfile, dateOfBirth: value },
                }))
              }
              placeholder="Date Of Birth"
              disabled={state.isLoading}
            />
          </Fieldset>
          {state.apiResponseStatus && state.apiResponseMessage && (
            <Fieldset>
              <MessageBox
                status={state.apiResponseStatus}
                message={state.apiResponseMessage}
              />
            </Fieldset>
          )}
          <Fieldset>
            <Button disabled={state.isLoading}>Save</Button>
          </Fieldset>
        </Form>
      </StyledFormContainer>
    </>
  );
};

export default withAppHOC(withAccountHOC(Profile, { title: "My Profile" }));
